module.exports = __webpack_public_path__ + "img/palaze.cac4a51f.svg";